import { j as m } from "../../../jsx-runtime-BwWtxLpl.js";
import "react";
import o from "prop-types";
import a from "classnames";
const i = ({ children: r, className: t = "", ...s }) => {
  const e = a({
    "motif-modal-footer": !0,
    [t]: !0
  });
  return /* @__PURE__ */ m.jsx("div", { ...s, className: e, "data-motif-modal-footer": !0, children: r });
};
i.propTypes = {
  children: o.node,
  className: o.string
};
export {
  i as MotifModalFooter
};
